var words = {
  common: {
    new_deploy_version: 'Hay una nueva versión del sistema.',
    clic_to_update: 'Actualizar',
    accept: 'Aceptar',
    approve: 'Aprobar',
    add: 'Añadir',
    cancel: 'Cancelar',
    description: 'Descripción',
    delete: 'Eliminar',
    title: 'Título',
    save: 'Guardar',
    faq: 'Preguntas más frecuentes',
    contact: 'Contáctenos',
    tos: 'Términos de servicio',
    policy: 'Política de privacidad',
    edit: 'Editar',
    confirmation: 'Confirmación',
    select_all: '.: Seleccionar todos :.',
    no_data: '.: No hay datos :.',
    select: '.: Seleccionar :.',
    selected: 'Seleccionado (s)',
    yes: 'Si',
    no: 'No',
    field_required: 'Campo requerido',
    pending: 'Pendiente',
    approved: 'Aprobado',
    declined: 'Rechazado',
    validate: 'Validar',
    all_a: 'Todas',
    massive: 'Masivo',
    download_template: 'Descargar plantilla',
    upload_file: 'Subir archivo',
    register: 'Registrar',
    search_commun: 'Buscar y solicitar Acceso a Tablas'
  },
  board: {
    titlePlaceholder: 'Ingresa un título para esta tarjeta',
    deleteDescription: '¿Estás seguro de que deseas eliminar esta tarjeta?',
    editCard: 'Editar tarjeta',
    deleteCard: 'Eliminar tarjeta',
    state: {
      TODO: 'QUE HACER',
      INPROGRESS: 'EN PROGRESO',
      TESTING: 'PRUEBAS',
      DONE: 'HECHO'
    }
  },
  chat: {
    online: 'Usuarios en línea ({count})',
    addChannel: 'Agregar canal',
    channel: 'Canal | Canales',
    message: 'Mensaje'
  },
  email: {
    compose: 'Escribir correo',
    send: 'Enviar',
    subject: 'Tema',
    labels: 'Etiquetas',
    emptyList: 'Lista de correo electrónico vacía',
    inbox: 'Bandeja de entrada',
    sent: 'Expedido',
    drafts: 'Borradores',
    starred: 'Sembrado de estrellas',
    trash: 'Basura',
    work: 'Trabajo',
    invoice: 'Factura'
  },
  todo: {
    addTask: 'Agregar tarea',
    tasks: 'Tareas',
    completed: 'Terminado',
    labels: 'Etiquetas'
  },
  dashboard: {
    activity: 'Actividad',
    weeklySales: 'Ventas semanales',
    sales: 'Ventas',
    recentOrders: 'órdenes recientes',
    sources: 'Fuentes de tráfico',
    lastweek: 'vs la semana pasada',
    orders: 'Pedidos',
    customers: 'Clientes',
    tickets: 'Tickets de soporte',
    viewReport: 'Vista del informe'
  },
  usermenu: {
    profile: 'Perfil',
    signin: 'Registrarse',
    dashboard: 'Tablero',
    signout: 'Desconectar'
  },
  error: {
    notfound: 'Página no encontrada',
    other: 'Ocurrió un error'
  },
  check: {
    title: 'Establecer nueva contraseña',
    backtosign: 'Volver a Iniciar sesión',
    newpassword: 'Nueva contraseña',
    button: 'Establezca una nueva contraseña e inicie sesión',
    error: 'El enlace de acción no es válido',
    verifylink: 'Verificando enlace ...',
    verifyemail: 'Verificando la dirección de correo electrónico ...',
    emailverified: '¡Correo Electrónico Verificado! Redirigiendo ...'
  },
  forgot: {
    title: '¿Se te olvidó tu contraseña?',
    subtitle: 'Ingrese la dirección de correo electrónico de su cuenta y le enviaremos un enlace para restablecer su contraseña.',
    email: 'Email',
    button: 'Petición para la recuperación de contraseña',
    backtosign: 'Volver a Iniciar sesión'
  },
  login: {
    title: 'Registrarse',
    email: 'Email',
    password: 'Contraseña',
    button: 'Registrarse',
    orsign: 'O inicia sesión con',
    forgot: '¿Se te olvidó tu contraseña?',
    noaccount: '¿No tienes una cuenta?',
    create: 'Crea uno aquí',
    error: 'La combinación de correo electrónico / contraseña no es válida'
  },
  register: {
    title: 'Crear una cuenta',
    name: 'Nombre completo',
    email: 'Email',
    password: 'Contraseña',
    button: 'Crear una cuenta',
    orsign: 'O regístrate con',
    agree: 'Al registrarse, acepta las',
    account: '¿Ya tienes una cuenta?',
    signin: 'Registrarse'
  },
  utility: {
    maintenance: 'En mantenimiento'
  },
  faq: {
    call: '¿Tiene otras preguntas? Por favor comuníquese'
  },
  ecommerce: {
    products: 'Productos',
    filters: 'Filtros',
    collections: 'Colecciones',
    priceRange: 'Rango de precios',
    customerReviews: 'Opiniones de los usuarios',
    up: 'y arriba',
    brand: 'Marca',
    search: 'Buscar producto',
    results: 'Resultados ({0} de {1})',
    orders: 'Pedidos',
    shipping: 'Envío',
    freeShipping: 'Envío gratis',
    inStock: 'En stock',
    quantity: 'Cantidad',
    addToCart: 'Añadir al carrito',
    buyNow: 'Compra ahora',
    price: 'Precio',
    about: 'Acerca de este artículo',
    description: 'Descripción',
    reviews: 'Reseñas',
    details: 'Detalles de producto',
    cart: 'Carro',
    summary: 'Resumen del pedido',
    total: 'Total',
    discount: 'Descuento',
    subtotal: 'Total parcial',
    continue: 'Seguir comprando',
    checkout: 'Revisa'
  },
  home_page_text: {
    access_requests: 'Solicitudes de acceso',
    acess_granted: 'Accesos aprobados',
    sandbox_created: 'Sandboxes creados',
    segments_exported: 'Segmentos exportados',
    created_audiences: 'Audiencias creadas',
    loaded_dataentries: 'Dataentries cargados',
    data_managment: 'Gestión de Datos',
    attribute_marketplace: 'Marketplace de Atributos',
    digital_audiences: 'Audiencias Digitales',
    customer_insights: 'Conocimiento del Cliente'
  },
  menu: {
    toolbar: {
      table_views: 'Tablas / Vistas',
      tables: 'Tablas',
      views: 'Vistas',
      business_terms: 'Términos de Negocio',
      tbl_datasources: 'Datasources TBL',
      tbl_dashboards: 'Dashboards TBL',
      pbi_datasets: 'Set de Datos PBI',
      pbi_reports: 'Reportes PBI',
      gds_reports: 'Reportes LS',
      gds_datasources: 'Datasources LS',
      all: 'Todos'
    },
    query_by: {
      title: 'Título',
      project: 'Proyecto',
      dataset: 'Dataset',
      description: 'Descripción',
      columns: 'Columnas',
      definition: 'Definición',
      also_known_as: 'También conocido como',
      area: 'Área',
      business_definition: 'Definición de negocio',
      data_element_name: 'Nombre del elemento de datos',
      data_operator: 'Operador de datos',
      domain: 'Dominio',
      official_source: 'Fuente oficial',
      org: 'Organización',
      subdomain: 'Subdominio',
      zone: 'Zona',
      data_owner: 'Data Owner'
    },
    query_by_search: 'Búsqueda Avanzada',
    object_type: 'Tipo de objeto',
    final_table: 'Tabla final',
    logout: 'Cerrar sesión',
    home_page: 'Página de inicio',
    use_metrics: 'Métricas de uso',
    use_metrics_sub: {
      summary: 'General',
      data_management: 'Módulo Gestión de Datos',
      attributes: 'Módulo Marketplace de Atributos',
      audiences: 'Módulo Audiencias Digitales',
      insights: 'Módulo Conocimiento del Cliente',
      mlops: 'Módulo MLOps',
      assets_corp: 'Gobierno de Activos',
      tables_government: 'Gobierno de Tablas',
      quality_government: 'Gobierno de Calidad',
      security_government: 'Gobierno de Seguridad',
      dashboard_government: 'Gobierno de Reportes',
      maturity_government: 'Madurez de Gobierno'
    },
    asset_governance: 'Gobierno de Activos',
    asset_governance_sub: {
      reports: 'Reportes',
      maintenance: 'Mantenimiento'
    },
    performance_evaluation: 'Evaluación de Desempeño',
    performance_evaluation_sub: {
      evaluation: 'Evaluación'
    },
    data_strategy: 'Estrategia de Datos',
    data_stretegy_sub: {
      assessment_maturity: 'Assessment de Madurez Analítica',
      assessment_maturity_admin: 'Mantenimiento de Assessment'
    },
    data_platform: 'Gestión de Datos',
    dp: {
      user_settings: 'Configuración de usuario',
      my_profile: 'Mi Perfil',
      initial_setup: 'Configuración Inicial',
      my_objects: 'Mis Objetos',
      my_pendings: 'Mis Pendientes',
      ownership: 'Asignación de Propietario',
      access_requests: 'Solicitudes de Acceso',
      change_metadata: 'Solicitudes de Cambio de Metadatos',
      massive_setup: 'Solicitudes Masivas',
      monitoring_audit: 'Seguimiento y Optimización',
      monitoring: 'Monitoreo',
      bigquery_consumption: 'Consumo BigQuery',
      inca_metrics: 'Métricas de INCA',
      access_management: 'Informe de Gestión de Accesos',
      tables_without_metadata: 'Informe de tablas sin metadata',
      executive_dashboard: 'Tablero Ejecutivo',
      operational_dashboard: 'Tablero Operativo',
      data_pipeline: 'Linaje Data Pipeline',
      power_bi_log: 'Informe de auditoría de uso en Power BI',
      manage_power_bi_log: 'Administración Informe Power BI',
      monitoring_billing: 'Monitoreo & Facturación',
      monitoring_billing_reports: 'Reportes',
      monitoring_billing_maintenance: 'Mantenimiento',
      my_tasks: 'Mis Tareas',
      table_assignments: 'Asignación de Tablas',
      bulk_load: 'Carga Masiva',
      download_metadata: 'Descargar Metadatos',
      data_operator_update: 'Actualización de Data Operator',
      add_tables_cron: 'Sincronizar Tablas',
      sync_table_flag_inca: 'Sincronizar Tabla Bigquery',
      tableau_objects: 'Objetos de Tableau',
      datasource_assignments: 'Asignaciones de Datasource',
      dashboard_assignments: 'Asignaciones de Dashboard',
      visualization_access: 'Accesos',
      business_glossary_terms_load_bulk: 'Carga masiva de términos de glosario de negocio',
      power_bi_objects: 'Objetos de Power BI',
      dataset_assignments: 'Asignaciones de Datasets',
      report_assignments: 'Asignaciones de Reportes',
      visualization_access_pbi: 'Accesos',
      data_studio_objects: 'Objetos de Looker Studio',
      report_assignments_gds: 'Asignaciones de Reportes LS',
      datasource_assignments_gds: 'Asignaciones de Datasources',
      visualization_access_gds: 'Accesos',
      all_requests: 'Solicitudes',
      data_quality: 'Calidad de Datos',
      data_quality_dataplex: 'Calidad de Datos (Dataplex)',
      profiling_validation: 'Tipos de Validación de Perfilamiento',
      profiling_history: 'Historial de Perfilamiento',
      profiling_score: 'Parámetros de Puntuación de Perfilamiento',
      profiling_dashboard: 'Tablero de Perfilamiento',
      user_profile: 'Perfiles de Data',
      up_area: 'Área',
      up_user_profile: 'Perfiles',
      up_table_details: 'Detalle de Tablas',
      up_profile_assignments: 'Asignación de Perfiles',
      data_strategy: 'Estrategia de Datos',
      business_glossary: 'Glosario de Negocio',
      user_module_access: 'Accesos por Módulo',
      strategy_management: 'Gestión de la Estrategia',
      evaluation_report: 'Assessment de Madurez Analítica',
      admin_evaluation_report: 'Mantenimiento de Assessment',
      artificial_intelligence: 'Herramientas IA',
      generative_image: 'Generar imagen por IA',
      migrations: 'Migraciones'
    },
    audience: 'Audiencias Digitales',
    aud: {
      segments: 'Segmentos',
      my_segments: 'Mis Segmentos',
      create_segment: 'Crear Segmento',
      cross_table: 'Ingresar Data Propia',
      audiences: 'Audiencias',
      my_audiences: 'Mis Audiencias',
      create_audience: 'Crear Audiencia',
      share: 'Uso',
      performance: 'Desempeño',
      monetization: 'Monetización',
      omnicanal: 'Análisis omnicanal',
      analytics: 'Analítica Digital',
      merge_segment: 'Cruzar Segmentos',
      exception: 'Solicitud de Datos',
      request_exception: 'Nueva Solicitud',
      requests: 'Solicitudes',
      configuration: 'Configuración',
      restriction: 'Datos Restringidos',
      attribute_restriction: 'Atributos Restringidos',
      config_flags: 'Configuración',
      coupons: 'Cupones',
      my_coupons: 'Mis Cupones',
      create_coupon: 'Crear Cupones',
      activators: 'Activadores',
      ads_accounts: 'Cuentas Publicitarias',
      reports: 'Reportes',
      my_campaigns: 'Campañas',
      upload_history: 'Historico cargas',
      variable: 'Variables',
      variable_group: 'Grupo de Variables',
      campaigns: 'Campañas',
      report: 'Reportes',
      sandbox: 'Sandbox'
    },
    attributes: 'Tienda de Atributos',
    data_ops: 'DataOps',
    dataops: {
      overview: 'Resumen',
      new_orchestration: 'Nueva Orquestación',
      import_script: 'Importar Script',
      sub_title: 'Modulo de DataOps',
      orchestration: 'Orquestación',
      executions_history: 'Historial de Ejecuciones'
    },
    attrs: {
      overview: 'Resumen',
      use_cases: 'Casos de Uso',
      business_cases: 'Casos de negocio',
      marketplace_setup: 'Configuración',
      search_attributes: 'Buscar Atributos',
      create_sandbox: 'Crear Sandbox',
      my_usecases: 'Mis casos de uso',
      my_groups: 'Mis Grupos',
      my_sandboxes: 'Mis Sandboxes',
      manage_productization_title: 'Gestionar Pases a Producción',
      manage_productization_subtitle: 'Las solicitudes de pases a producción que sean registradas en Productivizar modelo de tipo "base IDs con variables" se visualizarán en este apartado para poder revisar que cumplan con las políticas de seguridad y estándar de Marketplace Attributes.',
      sandboxes: 'Sandboxes',
      upload_my_data: 'Subir mi data',
      manage_requests: 'Gestionar Solicitudes',
      manage_production: 'Gestionar Pases a Producción',
      metrics: 'Reporte de métricas',
      manage_metrics: 'Mantenimiento de reporte de métricas',
      productize_model: 'Productivizar mi caso',
      create_attribute: 'Crear atributo',
      production_approvals: 'Aprobaciones de producción',
      user_tables_overview: 'Resumen de tablas de usuario',
      business_case_indicators: 'Indicadores de casos de negocio',
      attribute_master: 'Maestro de atributos',
      quality_report: 'Reporte de Calidad',
      manage_quality_report: 'Admin Reporte de Calidad',
      reports: 'Reportes',
      attribute_quality_shared: 'Calidad de Atributos compartidos',
      attribute_quality: 'Calidad de Atributos',
      attribute_quality_consistency: 'Calidad de Atributos - Consistencia'
    },
    analytic_services: 'Servicios Analíticos',
    analytic: {
      my_resources: 'Mis Recursos',
      resources_requests: 'Solicitudes de Recursos',
      pipelines: 'Pipelines',
      datasource: 'Datasource',
      store_procedure: 'Procedimiento almacenado',
      config: 'Configuración',
      resource: 'Recurso',
      ml_requests: 'Solicitudes',
      ml_components: 'Componentes',
      ml_configs: 'Configuraciones',
      ml_projects: 'Proyectos',
      ml_ops: 'ML Ops',
      ml_pipelines: 'Canalizaciones',
      ml_builder: 'Builder'
    },
    customer_insights: 'Conocimiento del Cliente',
    customer: {
      home: 'Inicio',
      somos1: 'Somos 1',
      somos1_home: 'Resumen',
      companies: 'Empresas',
      huascaran: 'Huascarán',
      maintenance: 'Mantenimiento',
      somos1_insights: 'Somos 1 - Reportes',
      somos1_reports: 'Reportes',
      companies_reports: 'Reportes',
      tracking_dataentry: 'Seguimiento Data Entry',
      huascaram_reports: 'Reportes',
      companies_reports_title: 'Empresas',
      huascaran_reports_title: 'Huascarán - Reportes',
      somos1_data_entry: 'Entrada de datos',
      usage_metricas: 'Métricas de uso',
      somos1_v2: 'Somos 1 - v2',
      somos1_v2_regional_1: 'Regional Indicators',
      somos1_v2_regional_2: 'Regional Ranking ',
      somos1_v2_configuration: 'Configuración'
    },
    mlops: 'MLOps',
    configuration: 'Configuraciones',
    config: {
      data_governance: 'Acciones Gobierno de Datos',
      roles: 'Roles y Usuarios',
      maintenance: 'Mantenimientos',
      business_domains: 'Dominios de Negocio',
      domain_maintenance: 'Organizaciones',
      whitelist_maintenance: 'Lista Blanca',
      log: 'Inicios de sesión',
      settings: 'Configuración'
    },
    chatbot_platform: 'Hub IA',
    ch: {
      permission_management: 'Gestion de permisos',
      user_management: 'Gestion de usuarios',
      userpermission_management: 'Gestion de usuarios - permisos',
      channel_management: 'Gestión de Canales',
      channel: 'Canales',
      channel_catalog: 'Catalogo de canales',
      connect_website: 'Conexión WebSite Chat',
      project_management: 'Gestión de Chatbots',
      data_center: 'Centro de Datos',
      bot_management: 'Configuración del bot',
      dashboard_management: 'Dashboard',
      search_engine: 'Motores de Búsqueda',
      chatbots: 'Chatbots',
      chatbot_main_menu: 'Menú principal',
      agent_management: 'Gestión de Agentes',
      config: 'Configuración'
    }
  },
  btns: {
    save: 'Guardar',
    search: 'Buscar',
    clean: 'Limpiar',
    back: 'Volver',
    preview: 'Pre Visualizar',
    close: 'Cerrar',
    new: 'Nuevo',
    cancel: 'Cancelar',
    ok: 'Ok',
    edit: 'Editar',
    remove: 'Eliminar',
    request: 'Solicitar',
    refresh: 'Refrescar',
    see_all: 'Ver todas',
    register_selection: 'Registrar selección',
    start_request: 'Iniciar solicitud',
    remove_item: 'Eliminar fila',
    add_item: 'Añadir fila',
    start: 'Empezar',
    add_table: 'Agregar Tabla',
    next: 'Siguiente',
    confirm: 'Confirmar'
  },
  titles: {
    search_filters: 'Filtros de Búsqueda',
    filters: 'Filtros',
    view_profile: 'Ver Perfil',
    edit_profile: 'Editar Perfil',
    about_me: 'Sobre mí',
    roles: 'Roles',
    general_description: 'Descripción General',
    my_segments: 'Mis Segmentos',
    create_segment: 'Crear Segmento',
    view_segment: 'Ver Segmento',
    edit_segment: 'Editar Segmento',
    cross_table: 'Ingresar Data Propia',
    my_audiences: 'Mis Audiencias',
    my_coupons: 'Mis Cupones',
    create_audience: 'Crear Audiencia',
    view_audience: 'Ver Audiencia',
    edit_audience: 'Actualizar Audiencia',
    create_coupons: 'Crear Cupones',
    view_coupons: 'Ver Cupones',
    edit_coupons: 'Actualizar Cupones',
    audience_detail: 'Detalle de Audiencia',
    coupons_detail: 'Detalle de Cupones',
    my_objects: 'Mis Objetos',
    my_notifications: 'Mis Notificaciones',
    use_case_report: 'Reporte de Caso de Uso',
    add_base_ids: 'Agregar Base IDs',
    add_inca_base: 'Añadir Base INCA',
    add_sandbox_base: 'Añadir Base Sandbox',
    selected_attributes: 'Atributos seleccionados',
    edit_users_sandbox: 'Editar usuarios del Sanbox',
    add_attributes: 'Nuevo grupo de atributos',
    edit_attributes: 'Editar atributos',
    edit_group_attributes: 'Editar grupo de atributos',
    description: 'Descripción',
    attributes: 'Atributos',
    input_attributes: 'Atributos de entrada',
    export_events: 'Eventos de exportación',
    output_attributes: 'Atributos de salida',
    logs: 'Eventos',
    aws_exports: 'Exportación (AWS)',
    base_exports: 'Exportación Base',
    view_update_request: 'Solicitud de actualización de entorno de trabajo',
    view_create_request: 'Solicitud de creación de entorno de trabajo',
    error: 'Algo ha salido mal',
    success: 'Éxito',
    sanbdox_requests: 'Solicitudes de Sandbox',
    merge_segments: 'Cruzar Segmentos',
    ml_requests: 'Solicitudes ML',
    ml_components: 'Componentes',
    ml_templates: 'Plantillas',
    ml_create_template: 'Crear Plantilla',
    change_enviroment: 'Cambiar entorno',
    transformed_detail: 'Detalle de Atributos Transformados',
    extend_validity: 'Aumentar vigencia'
  },
  error_messages: {
    error_general: 'No se ha podido completar correctamente tu solicitud. Inténtalo nuevamente.',
    register_use_case: 'No se ha podido completar correctamente el registro del caso de uso. Inténtalo nuevamente',
    duplicate_base: 'La base ya se encuentra registrada',
    not_attributes_selected: 'No existen atributos seleccionados',
    min_attribute_selection: 'Debes seleccionar al menos un atributo'
  },
  success_messages: {
    general: 'Tu sandbox ha sido aprobado con éxito.',
    operation_success: 'La operación se realizó con éxito.',
    general_processing: 'Se está procediendo con tu solicitud, en cuanto finalice se le enviará una notificación.',
    export_sandox: 'Se exportó el Sandbox',
    sandbox_request_rejected: 'La solicitud de Sandbox fue rechazada',
    request_approved: 'La solicitud fue aprobada',
    update: 'Se ha actualizado correctamente',
    requested: 'Solicitud enviada con éxito',
    usecase_paused: 'El caso de uso fue pausado',
    usecase_observed: 'El caso de uso fue observado'
  },
  rejected_messages: {
    request_rejected: 'La solicitud fue rechazada'
  },
  // Vuetify components translations
  $vuetify: {
    badge: 'Insignia',
    close: 'Cerca',
    dataIterator: {
      noResultsText: 'No se encontraron registros coincidentes',
      loadingText: 'Cargando elementos ...'
    },
    dataTable: {
      itemsPerPageText: 'Filas por página:',
      ariaLabel: {
        sortDescending: 'Ordenados descendente.',
        sortAscending: 'Ordenado ascendente.',
        sortNone: 'Sin clasificar.',
        activateNone: 'Activar para eliminar la clasificación.',
        activateDescending: 'Activar para ordenar de forma descendente.',
        activateAscending: 'Activar para ordenar de forma ascendente.'
      },
      sortBy: 'Ordenar por'
    },
    dataFooter: {
      itemsPerPageText: 'Artículos por página:',
      itemsPerPageAll: 'Todas',
      nextPage: 'Siguiente página',
      prevPage: 'Pagina anterior',
      firstPage: 'Primera página',
      lastPage: 'Última página',
      pageText: '{0} - {1} de {2}'
    },
    datePicker: {
      itemsSelected: '{0} seleccionado',
      nextMonthAriaLabel: 'Próximo mes',
      nextYearAriaLabel: 'El próximo año',
      prevMonthAriaLabel: 'Mes anterior',
      prevYearAriaLabel: 'Año anterior'
    },
    noDataText: 'Datos no disponibles',
    carousel: {
      prev: 'Visual anterior',
      next: 'Siguiente visual',
      ariaLabel: {
        delimiter: 'Diapositiva de carrusel {0} de {1}'
      }
    },
    calendar: {
      moreEvents: '{0} más'
    },
    fileInput: {
      counter: '{0} archivos',
      counterSize: '{0} archivos ({1} en total)'
    },
    timePicker: {
      am: 'AM',
      pm: 'PM'
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Navegación de paginación',
        next: 'Siguiente página',
        previous: 'Pagina anterior',
        page: 'Ir a la página {0}',
        currentPage: 'Página actual, página {0}'
      }
    }
  },
  botones: {
    boton_crear: 'Crear',
    boton_add: 'Agregar',
    boton_cancelar: 'Cancelar',
    boton_aceptar: 'Aceptar',
    boton_buscar: 'Buscar',
    boton_guardar: 'Guardar',
    boton_volver: 'Volver',
    boton_yes: 'SÍ',
    boton_apply: 'Aplicar',
    boton_reset: 'Reiniciar',
    boton_download: 'Descargar',
    boton_aceptar_solicitudes: 'Aceptar Solicitudes',
    boton_siguiente: 'Siguiente',
    boton_primero: 'Primero',
    boton_anterior: 'Anterior',
    boton_aceptar_rechazar: 'Aceptar/Rechazar',
    boton_hide: 'Ocultar Detalles',
    boton_busqueda_avanzada: 'Búsqueda Avanzada',
    descargar: 'Descargar registros actuales',
    boton_asignar: 'Asignar',
    boton_paso_anterior: 'Paso Anterior',
    boton_download_metadata: 'Descargar Metadata',
    boton_descargar_template: 'Descargar plantilla',
    boton_cargar_archivo: 'Cargar Archivo',
    boton_confirmar: 'Confirmar',
    boton_cargar_csv: 'Seleccionar Archivo CSV',
    boton_detalles: 'Detalles',
    boton_descargar_csv: 'Descargar CSV',
    boton_show_all_tables: 'Mostrar todas las tablas',
    boton_show_some_tables: 'Mostrar algunas tablas',
    boton_asignar_operator: 'Asignar operador de datos',
    boton_limpiar: 'Limpiar',
    boton_dashboard_all_operator: 'ASIGNAR TODOS LOS DASHBOARDS A OPERADOR TEMPORAL',
    boton_dataset_all_operator: 'ASIGNAR TODOS LOS DATASETS A OPERADOR TEMPORAL',
    boton_report_all_operator: 'ASIGNAR TODOS LOS REPORTES A OPERADOR TEMPORAL',
    boton_datasource_all_operator: 'ASIGNAR TODOS LOS DATASOURCES A OPERADOR TEMPORAL',
    boton_renew_access: 'Renovar Acceso',
    boton_search_table: 'Buscar Tabla',
    boton_turn_on_work_env: 'Encender',
    boton_turn_off_work_env: 'Apagar',
    boton_update: 'Actualizar',
    boton_monitoring: 'Monitoreo',
    boton_upload_image: 'Subir imagen',
    boton_copiar: 'Copiar',
    botn_eliminar: 'Eliminar',
    boton_filtrar: 'Filtrar',
    boton_glossary: 'Ver Glosario',
    boton_sync: 'Sincronizar',
    boton_assign_all: 'Asignar todo',
    boton_renew_assignment: 'Renovar asignación',
    boton_massive_upload_users: 'Carga Masiva',
    boton_select_all: 'Seleccionar todos'
  },
  filtros: {
    search_filters: 'Filtros de Búsqueda',
    nombre: 'Nombre',
    tipo: 'Tipo',
    rango: 'Rango de Fechas',
    plataforma: 'Plataforma',
    estado: 'Estado',
    object: 'Nombre de objeto',
    data_operator: 'Operador',
    path: 'Nombre de ruta',
    environment: 'Entorno:',
    domain: 'Dominio:',
    activate: 'Activar',
    subdomain: 'Subdominio:',
    organization: 'Organización:',
    empresa: 'Empresa',
    register_date: 'Fecha de Registro',
    expire_date: 'Fecha de Expiración',
    modified_date: 'Fecha de modificación',
    created_date: 'Fecha de creación'
  },
  frases: {
    no_requests: 'No tienes solicitudes',
    new_tab: 'Abrir en nueva pestaña',
    assign: 'Asignar metadata en entorno dev/test',
    step_1: 'Paso 1',
    step_2: 'Paso 2',
    step_3: 'Paso 3',
    bulk_load: 'Detalles de Carga Masiva',
    asignar_operator_modal: 'Asignar operador de datos desde ',
    new_domain: 'Añadir nuevo dominio',
    new_subdomain: 'Añadir nuevo subdominio',
    subdomain: 'Subdominio de negocio',
    delete_domain: 'Delete Domain',
    update_domain: 'Update Domain',
    delete_subdomain: 'Delete Subdomain',
    update_subdomain: 'Update Subdomain',
    no_access: 'No tienes accesos',
    no_tables: 'No tienes tablas',
    no_found: 'No se encontró nada',
    loading: 'Cargando...',
    search_table: 'Buscar por tabla',
    select_option: 'Selecciona una opción...',
    project_id: 'ID de proyecto',
    dataset_id: 'ID de dataset',
    table_name: 'Nombre de Tabla',
    search_datasource: 'Buscar',
    dev_test: 'Desarrollo / Prueba',
    prod: 'Producción',
    search_object: 'Buscar por objeto',
    search_operator: 'Buscar por operador',
    search_path: 'Buscar por ruta',
    show_role: 'VER DETALLES DE ROL',
    hide_role: 'OCULTAR DETALLES DE ROL',
    search_tags: 'Buscar etiquetas',
    choose_roles: 'ELEGIR ROLES',
    delete_rol: '¿Eliminar rol?',
    search_email: 'Buscar por Correo',
    delete_bdomain: 'Algunos subdominios y términos podrían verse afectados. ¿Desea continuar?',
    delete_bsubdomain: 'Algunos términos podrían verse afectados. ¿Desea continuar?',
    new_bterm: 'Nuevo término de negocio',
    edit_bterm: 'Actualizar término de negocio',
    delete_bterm: 'Este término está relacionado a otros, ¿desas eliminarlo de todas formas? Esta acción puede tomar un tiempo',
    is_critical: '¿Es crítico?',
    active: '¿Está activo?',
    shared: '¿Es compartido?',
    relationships: 'Relaciones',
    is_contained: 'Está contenido en ',
    is_related: 'Es un término relacionado con',
    is_type: 'Es un tipo de',
    is_used: 'Es usado para calcular',
    activo: 'Activo',
    updated_by: 'Modificado por',
    update_date: 'Fecha de modificación',
    sure: '¿Estás seguro/a?',
    deactivate: 'Desactivar',
    delete: 'Eliminar',
    delete_user: 'Eliminar usuario',
    delete_confirm: 'Confirmar eliminación',
    activate: 'Activar',
    email: 'Correos',
    new_email: 'Asignar nuevo correo',
    permission: 'Permisos',
    logs: 'Registros',
    email_inca: 'Correo (INCA)',
    no_records: 'No hay registros para mostrar',
    delete_workspace: 'La cuenta de servicio debe tener permisos de administrador en el workspace. ¿Desea continuar?',
    app: 'Apps',
    type: 'Puntuación por tipo de validación',
    field_type: 'Puntuación por tipo de campo',
    table_type: 'Umbrales por tipo de validación de tabla',
    choose_type: 'Elige un tipo ...',
    filter: 'Filtro',
    type_search: 'Escribe para buscar',
    table_filter: "* Filtro de tabla: Debe estar en el lenguaje de BigQuery y SQL (ejemplo: transaction_date = '2021-06-01')",
    profiling_version: 'Versión de perfilamiento',
    quantity: 'C = Cantidad',
    q_increased: 'El indicador ha incrementado comparado al perfilamiento anterior',
    q_decreased: 'El indicador ha decrementado comparado al perfilamiento anterior',
    q_same: 'El indicador es el mismo comparado al perfilamiento anterior',
    rows_quantity: 'Cantidad de filas',
    table_key: 'LLave(s) de tabla',
    unique_key: '% Llaves únicas',
    reference_score: 'Puntuación de referencia:',
    comments: 'Comentarios',
    enter: 'Escribe un comentario',
    edit_profiling: 'EDITAR PERFILAMIENTO',
    execute_profiling: 'EJECUTAR PERFILAMIENTO',
    error_profiling: 'ERROR DE PERFILAMIENTO',
    want_error: '¿Qué quieres hacer con el error?',
    execute_error: 'EJECUTAR PERFILAMIENTO DESPUÉS DEL ERROR',
    new_execution: 'NUEVA EJECUCIÓN DE PERFILAMIENTO',
    want_profiling: '¿Quieres perfilar esta tabla?',
    create: 'Crear',
    edit: 'Editar',
    view: 'Ver',
    sensitive: 'Datos sensibles:',
    database: 'Base de datos:',
    data_operator: 'Operador:',
    attach: 'ADJUNTAR',
    project: 'Proyecto:',
    table: 'Tabla:',
    request_work_env: 'Solicitar un entorno de trabajo',
    view_request: 'Revisar solicitud',
    consumption_work_env: 'Consumo de entornos de trabajo',
    successfully_updated: 'Actualizado exitosamente',
    successfully_registered: 'Registrado exitosamente',
    rejected: 'La tabla fue rechazada',
    no_description: 'Descripción no disponible',
    no_notifications_title: 'Sin notificaciones',
    no_notifications: 'No tienes notificaciones aún',
    welcome: '¡Bienvenido,',
    use_case: 'Caso de Uso',
    select_base: 'Seleccionar base',
    select_column: 'Periodo',
    alert_period_column: "El campo de período debe estar en formato de fecha y tener la estructura de 'yyyy-mm-dd', donde 'dd' siempre será '01'. Por ejemplo: '2023-05-01'.",
    alert_add_sandbox: "Nota: No añadir información sensible, es decir, información que esté relacionada uno a uno con el 'party_id' de la empresa. Por ejemplo: 'nro_documento', 'nro_placa', 'nro_contrato', otros códigos internos, etc.",
    choose_party_id: 'Selecciona ID persona',
    reason: 'Motivo',
    reason_required: 'El motivo es obligatorio',
    party_id_required: "No se encontró la columna identidad (party_id / id_sandbox).",
    select_all: 'Seleccionar Todos',
    register: 'Registrar',
    update: 'Actualizar',
    attributes_overview: 'Explora las novedades que el Marketplace de Atributos tiene para ti',
    table_view: 'Tabla o Vista',
    view_id_copied: '¡Id de vista copiado!',
    code_copied: 'Código copiado',
    owner: 'propietario',
    attrs_overview_message: 'Explora las novedades que el Marketplace de Atributos tiene para ti',
    insights_home: 'Bienvenido a la sección de Conocimiento del Cliente',
    attrs_sandbox_owner: 'Propietario del Sandbox',
    search_table_view: 'Search Table / View',
    update_list: 'Update List',
    search: 'Búsqueda',
    attributes_selection: 'Selección de atributos',
    attributes_only_one_sa: 'Solo se permite añadir una cuenta de servicio',
    warning_massive_approve_access: 'Debe seleccionar al menos una solicitud',
    will_approve: 'Se van a aprobar',
    show_inheritance: 'Mostrar herencia',
    tables: 'Tablas',
    list_values: 'Lista de valores',
    list_classifications: 'Lista de clasificaciones (Tags)',
    productize_mi_usecase: 'Productivizar mi caso',
    productize_usecase: 'Productivizar caso de uso',
    identified_ids: 'IDs identificados',
    duplicated_ids: 'IDS duplicados',
    not_identified_ids: 'IDs no identificados',
    export_transformed_attributes: 'Exportación de atributos transformados',
    attributes_group: 'Mis Grupos'
  },
  nouns: {
    requests: 'solicitud(es)'
  },
  warnings: {
    are_you_sure: '¿Estás seguro?',
    cancel_sandbox_request: 'Se eliminará la lista de atributos seleccionada y los campos que ya hayas llenado, ¿Estás seguro?',
    sync_table: '¿Estás seguro que deseas sincronizar esta tabla?'
  },
  form_profile: {
    display_name: 'Nombre',
    email: 'Correo',
    phone_number: 'Número de teléfono',
    default_language: 'Idioma por defecto',
    created: 'Creado',
    las_sign_in: 'Último inicio de sesión'
  },
  form_dops: {
    api_filters: 'Filtros del API',
    company: 'Nombre de la compañía :',
    group: 'Nombre del grupo :',
    zone: 'Nombre de la zona :',
    execution_date: 'Fecha de ejecución :',
    job_code: 'Código de trabajo :',
    local_filters: 'Filtros locales',
    job_type: 'Tipo de trabajo :',
    job_status: 'Estado de trabajo :',
    legend: 'Leyenda',
    orch: 'Orquestación',
    trans: 'Transformación'
  },
  form_segmento: {
    nombre: 'Nombre del segmento',
    descripcion: 'Descripción',
    tipo: 'Tipo de segmento',
    formato: 'Formato: INCA_Empresa_caracteristicas_MMYYYY',
    categorias: 'Categorías',
    usuarios: 'Usuarios Únicos',
    filtros: 'Filtros:',
    preVisualizacion: 'Pre Visualizar',
    crearAudiencia: 'Crear Audiencia',
    datosGenerales: 'Datos Generales',
    atributos: 'Atributos',
    resumen: 'Resumen',
    total_segment: 'Total Segmento',
    total_match: 'Total Match',
    total_table: 'Total Tabla/Vista',
    total_match_table: 'Total Match',
    total_restriction: 'Total Restricción',
    total_restriction_help: 'Total de usuarios únicos restringidos.',
    total_segment_help: 'Total de usuarios únicos que cumplen con las condiciones de los filtros elegidos.',
    total_match_help: 'Total de usuarios únicos que tiene un dato de contactabilidad del Total de Segmento.',
    total_table_help: 'Total de usuarios únicos de la Tabla/Vista.',
    total_merge_help: 'Total de usuarios únicos del Cruce.',
    total_match_table_help: 'Total de usuarios únicos que tiene un dato de contactabilidad del Total de la Tabla/Vista.',
    total_match_merge_help: 'Total de usuarios únicos que tiene un dato de contactabilidad del Total del Cruce.',
    tooltip_no_edit_segment: 'No puede editar este segmento, porque está asociado a {} audiencia(s).'
  },
  form_request_access: {
    nombre_segmento: 'Nombre Segmento',
    empresa: 'Solicitar Datos de',
    fecha_hasta: 'Fecha Hasta',
    guardar: 'Guardar',
    volver: 'Volver'
  },
  tbl_request_access: {
    from: 'Solicitado Por',
    to: 'Empresa Solicidata',
    request_by: 'Usuario Solicitante',
    fecha: 'Fecha Estado',
    fecha_hasta: 'Fecha Hasta',
    estado: 'Estado',
    acciones: 'Acciones'
  },
  form_cruzar: {
    nombre: 'Nombre',
    proyecto: 'Proyecto',
    tabla: 'Tabla'
  },
  form_audiencia: {
    segmento: 'Segmento',
    segment_type_name: 'Tipo de Segmento',
    audiencia: 'Audiencia',
    coupons: 'Cupones',
    choose_frencuency: 'Elija una frecuencia',
    desde: 'Desde',
    hasta: 'Hasta',
    frecuencia: 'Frecuencia de actualización',
    plataforma: 'Plataformas',
    update_date: 'Dia de Actualización',
    ad_account: 'Cuenta Publicitaria',
    talonone_application: 'Aplicación',
    talonone_campaign: 'Campaña',
    talonone_pattern: 'Patrón de Cupones',
    talonone_valid_characters: 'Caracteres Válidos',
    audience_type_google: 'Tipo de audiencia en Google Ads',
    app_id: 'App ID',
    app_id_type: 'Tipo de App ID',
    select_app_id_type: 'Seleccione el tipo de App ID'
  },
  form_attrs_use_case: {
    organization: 'Organización',
    use_case: 'Caso de Uso',
    users: 'Usuarios',
    attributes_selected_number: '# Atributos seleccionados',
    expiration_date: 'Fecha de expiración',
    detail: 'Detalle del Caso de Uso',
    technical_name: 'Nombre técnico',
    response: 'Respuesta',
    sandbox_project: 'Proyecto Sandbox',
    sandbox_dataset: 'Dataset Sandbox',
    generated_views: 'Vistas Generadas',
    filter: 'Filtro utilizado',
    business_area: 'Área de negocio',
    columns_validation: 'Validación de Columnas'
  },
  form_attrs_productize_usecase: {
    model: 'Modelo',
    download_rules: 'Descargar Lineamientos',
    use_case: 'Caso de Uso',
    type_export: 'Tipo de exportación',
    segment: 'Segmento',
    table_name: 'Nombre de tabla',
    destination_scheme: 'Esquema destino (AWS)',
    process_date: 'Fecha del proceso',
    script: 'Adjuntar Script',
    unique_load: 'Carga única',
    attach_file: 'Adjuntar archivo',
    next: 'Siguiente',
    back: 'Anterior',
    finish: 'Guardar y Ejecutar',
    request: 'Solicitar',
    validate: 'Validate',
    description: 'Detalle de exportación',
    description_segment: 'Descripción segmento',
    description_table: 'Descripción de la tabla',
    message_no_tables: 'No se encuentran tablas',
    user: 'Usuario',
    date_hour: 'Fecha y hora',
    frecuency: 'Frecuencia',
    day: 'Día',
    download_file: 'Descargar archivo',
    approve: 'Aprobar',
    deny: 'Rechazar',
    response_text: 'Respuesta de solicitud',
    change: 'Cambiar',
    organization: 'Organización',
    exported_table: 'Tabla Publicada'
  },
  tabla_segmentos: {
    empresa: 'EMPRESA',
    nombre: 'NOMBRE',
    tipo: 'TIPO',
    mod: 'FECHA DE MODIFICACIÓN',
    usuarios: 'USUARIOS ÚNICOS',
    total_audiences: 'TOTAL AUDIENCIAS',
    acciones: 'ACCIONES'
  },
  tabla_audiencias: {
    empresa: 'EMPRESA',
    nombre: 'NOMBRE',
    plataforma: 'PLATAFORMA',
    estado: 'ESTADO',
    fecha: 'FECHA CREACIÓN',
    registros: 'REGISTROS',
    acciones: 'ACCIONES',
    last_process_date: 'ÚLTIMA ACTUALIZACIÓN',
    end_date: 'FECHA DE EXPIRACIÓN'
  },
  tabla_solicitudes: {
    name: 'Código',
    type: 'Tipo',
    status: 'Estado',
    created_date: 'Fecha Solicitud',
    user_request: 'Usuario',
    actions: 'Acciones'
  },
  tabla_componentes: {
    name: 'Nombre',
    type: 'Tipo',
    created_date: 'Fecha Creación',
    user_created: 'Usuario',
    actions: 'Acciones'
  },
  table_notifications: {
    title: 'TÍTULO',
    description: 'DESCRIPCIÓN',
    created_date: 'FECHA',
    created_by: 'EMISOR',
    actions: 'ACCIONES'
  },
  table_my_work_envs: {
    notebook: 'Notebook',
    project_gcp: 'Proyecto de GCP',
    link: 'Link',
    requested_date: 'Fecha de solicitud',
    pr_firebase: 'Proyecto de Firebase',
    applicant: 'Solicitante',
    init: 'Iniciativa',
    company: 'Empresa',
    status: 'Estado',
    actions: 'Acciones'
  },
  table_ownership_history: {
    organization: 'Organización',
    use_case: 'Caso de Uso',
    scenario: 'Escenario',
    date_created: 'Fecha Creación',
    attributes: 'Atributos',
    owner: 'Propietario',
    status: 'Estado',
    states: {
      active: 'Activo',
      inactive: 'Inactivo',
      saved: 'GUARDADO',
      requested: 'SOLICITADO',
      approved: 'APROBADO',
      rejected: 'RECHAZADO',
      finished: 'FINALIZADO',
      error: 'ERROR'
    },
    actions: {
      see_report: 'Ver reporte',
      register_filter: 'Registrar filtro',
      add_ids: 'Añadir Base INCA',
      edit_attrs: 'Editar atributos',
      edit_users: 'Editar usuarios',
      go_sandbox: 'Ir a Sandbox',
      add_sandbox_base: 'Añadir Base Sandbox',
      desencriptar_idsandbox: 'Exportar Base',
      edit_request: 'Modificar solicitud',
      export_aws: 'Exportar a AWS',
      increase_validity: 'Aumentar vigencia',
      create_attribute_group: 'Crear grupo'
    }
  },
  table_sandbox_requests: {
    organization: 'Organización',
    use_case: 'Caso de Uso',
    owner: 'Propietario',
    date_created: 'Fecha de Solicitud',
    attributes: 'Atributos'
  },
  table_add_ids: {
    attribute: 'Atributo',
    definition: 'Definición',
    type: 'Tipo'
  },
  table_selected_attributes: {
    name: 'Nombre',
    description: 'Descripción',
    data_type: 'Tipo',
    percentage: '% no nulo'
  },
  table_attributes_use_case_detail: {
    attribute: 'Atributo',
    description: 'Descripción',
    source: 'Origen',
    data_type: 'Tipo de dato'
  },
  table_use_case_logs: {
    description: 'Descripción',
    log_type: 'Tipo de evento',
    applicant: 'Usuario',
    response: 'Respuesta',
    created: 'Creación'
  },
  crear_audiencia: {
    diaria: 'Diaria',
    semanal: 'Semanal',
    quincenal: 'Quincenal',
    mensual: 'Mensual',
    semestral: 'Semestral',
    fechaInicio: 'Fecha de Inicio',
    fechaFin: 'Fecha Fin'
  },
  descripcion: {
    des_business_glossary: 'Representa un medio para compartir vocabulario interno dentro de una organización',
    my_access: 'Lista todas las tablas de bigquery a las que tienes acceso.',
    my_tables: 'Lista todas las tablas de bigquery en las que eres operador.',
    my_bterms: 'Lista todos los términos de negocio en los que eres operador.',
    my_tbl_datasources: 'Lista todos los dataources de Tableau en los que eres operador.',
    my_tbl_dashboards: 'Lista todos los dashboards de Tableau en los que eres operador.',
    my_pbi_datasets: 'Lista todos los datasets de PowerBI en los que eres operador',
    my_pbi_reports: 'Lista todos los reportes de PowerBI en los que eres operador',
    my_gds_reports: 'Lista todos los reportes de Looker Data Studio en los que eres operador',
    my_gds_datasources: 'Lista todos los datasources de Looker Data Studio en los que eres operador',
    o_my_tables: 'Aprobaciones de operadores para tablas de BigQuery',
    o_my_datasources: 'Aprobaciones de operadores para datasources de Tableau',
    o_my_dashboards: 'Aprobaciones de operadores para dashboards de Tableau',
    o_my_datasets: 'Aprobaciones de operadores para datasets de PowerBI',
    o_my_reports: 'Aprobaciones de operadores para reportes de PowerBI',
    o_my_gds: 'Aprobaciones de operadores para reportes de Looker Data Studio',
    o_my_gds_datasources: 'Aprobaciones de operadores para datasources de Looker Data Studio',
    a_my_tables: 'Solicitudes de acceso para tablas de BigQuery',
    a_my_datasources: 'Solicitudes de acceso para datasources de Tableau',
    a_my_dashboards: 'Solicitudes de acceso para dashboards de Tableau',
    a_my_datasets: 'Solicitudes de acceso para datasets de PowerBI',
    a_my_reports: 'Solicitudes de acceso para reportes de PowerBI',
    a_my_gds: 'Solicitudes de acceso para reportes de Looker Data Studio',
    a_my_gds_datasources: 'Solicitudes de acceso para datasources de Looker Data Studio',
    c_my_tables: 'Solicitudes de cambio de metadata para tablas de BigQuery',
    c_my_datasources: 'Solicitudes de cambio de metadata para datasources de Tableau',
    c_my_dashboards: 'Solicitudes de cambio de metadata para dashboards de Tableau',
    c_my_datasets: 'Solicitudes de cambio de metadata para datasets de PowerBI',
    c_my_reports: 'Solicitudes de cambio de metadata para reportes de PowerBI',
    c_my_gds: 'Solicitudes de cambio de metadata para reportes de Looker Data Studio',
    c_my_gds_datasources: 'Solicitudes de cambio de metadata para datasources de Looker Data Studio',
    add_tables: 'Agrega tablas sin metadata a la plataforma INCA (sólo si las tablas no existen en la opción "Asignación de Tablas"',
    ownership_history: 'Checa todos tus sandbox creados',
    ownership_requests: 'Este es el listado de todas las solicitudes pendientes de aprobación generadas por las organizaciones.',
    use_case_report: 'Visualiza el detalle del caso de uso',
    see_request_detail: 'Visualiza el detalle de la solicitud',
    requested_reason: 'Motivo de la solicitud',
    add_base_ids: 'Aquí podrá buscar la base de clientes y seleccionar las columnas que desea añadir',
    register_filter: 'Seleccione la base de identificadores con la cual se filtrarán las bases de atributos. Esta tabla debe estar registrada en el Sandbox. Solo se podrá registrar una base por Sandbox.',
    add_own_base: 'Selecciona la base creada en el Sandbox y su party_id para poder transformar le id',
    select_columns: 'Ahora selecciona las columnas que deseas registrar en tu tabla (la selección de todas las páginas esta habilitada)',
    use_case: 'Nombre del Sandbox',
    segment: 'Segmento que se desea registrar',
    segment_process_date: 'Fecha que se registró el segmento',
    attrs_script_sql: 'Consulta SQL que genera la base de IDs',
    companies_insights: 'Solo verás habilitados los accesos de tu organización',
    companies_insights_title: 'Explora los reportes que tenemos para ti',
    detail: 'Detalle'
  },
  reglas: {
    nombre: 'El nombre es requerido',
    nombre_min: 'El nombre debe tener al menos 3 caracteres',
    nombre_max: 'El nombre debe tener máximo 20 caracteres',
    nombre_max_15: 'El nombre debe tener máximo 15 caracteres',
    nombre_max_10: 'El nombre debe tener máximo 10 caracteres',
    nombre_formato: 'Solo se acepta letras, números  y "_"',
    alias: 'Alias es requerido',
    descripcion: 'La Descripción es requerida',
    organization: 'La organización es requerida',
    proyecto: 'El Proyecto es requerido',
    dataset: 'El Dataset es requerido',
    tabla: 'La Tabla es requerida',
    end_date: 'La fecha final es requerida',
    external_user_type: 'Seleccione un tipo de usuario',
    phone_required: 'El número de teléfono es requerido.',
    phone_regex: 'El teléfono debe tener un + y el código de país antes del número. (Ej: +51)',
    response_required: 'La respuesta es requerida',
    period: 'El periodo es requerido',
    field: 'Este campo es requerido',
    field_min: 'El campo debe contener al menos 3 caracteres',
    field_max: 'El campo debe contener como máximo 200 caracteres',
    wrong_emails: 'Emails incorrectos',
    invalid_email: 'El email debe pertenecer a las empresas de Intercorp',
    email_no_inca: 'E-mail no autorizado: requiere rol (attribute_user)',
    duplicate_email: 'El email ya se encuentra registrado',
    attributes_wrong_domain: 'El email debe pertenecer al dominio del caso de uso',
    insights_min_2_update_hours: 'Se debe seleccionar al menos 2 horas de actualización',
    domain: 'Dominio necesario',
    min_character_insights_3: 'El nombre debe tener al menos 3 caracteres',
    max_character_insights_45: 'El nombre debe tener máximo 45 caracteres',
    max_character_insights_150: 'El nombre debe tener máximo 150 caracteres',
    year: 'El año es requerido'
  },
  rules_work_env: {
    email: 'El email es requerido',
    email_invalid: 'El email debe ser válido',
    business_case: 'El caso de negocio es requerido',
    company: 'La empresa es requerida',
    project_gcp: 'El proyecto de GCP es requerido',
    instance_type: 'El tipo de máquina es requerido',
    image_type: 'El tipo de imagen es requerido'
  },
  tabs: {
    access: 'Mis accesos',
    tables: 'Mis tablas',
    bterms: 'Mis términos de negocio',
    tbl_datasources: 'Mis datasources TBL',
    tbl_dashboards: 'Mis dashboards TBL',
    pbi_datasets: 'Mis datasets PBI',
    pbi_reports: 'Mis reportes PBI',
    gds_reports: 'Mis reportes LS',
    gds_datasources: 'Mis datasources LS',
    pages: 'PÁGINAS',
    bterm: 'TÉRMINOS DE NEGOCIO',
    user: 'USUARIOS',
    lineage: 'LINAJE',
    logs: 'REGISTROS',
    rules: 'REGLAS',
    columns: 'COLUMNAS',
    execution: 'DETALLES DE EJECUCIÓN',
    profiling: 'PERFILAMIENTO',
    connections: 'CONEXIONES',
    general: 'General',
    specifications: 'Especificaciones',
    relationships: 'Relaciones',
    graphical_relationships: 'Relaciones gráficas',
    related_objects: 'Objetos relacionados',
    values: 'Valores',
    classifications: 'Clasificaciones',
    audit_logs: 'Logs de auditoría',
    sandbox_internal: 'Interno'
  },
  fields: {
    type: 'Tipo',
    business_term: 'Término de negocio',
    domain: 'Dominio',
    subdomain: 'Subdominio',
    also_known_as: 'También conocido como',
    accountable: 'Responsable',
    status: 'Estado',
    critical: 'Crítico',
    shared: 'Compartido',
    definition: 'Definición'
  },
  tablas: {
    table: 'Tabla',
    columns: 'Columnas',
    column: 'Columna',
    rows: 'Filas',
    creation_time: 'Fecha de Creación',
    expiration_date: 'Fecha de Expiración',
    actions: 'Acciones',
    enviroment: 'Entorno',
    bterm: 'Término de Negocio',
    definition: 'Definición',
    values: 'Valores',
    total: 'Total de tablas',
    rol: 'Rol',
    views: 'Vistas',
    report: 'Reporte',
    pages: 'Páginas',
    applicant: 'Solicitante',
    request_date: 'Fecha de solicitud',
    area: 'Área',
    profile: 'Perfil',
    status: 'Estado',
    dominio_empresa: 'Dominio Empresa',
    organization: 'Organización',
    benefited: 'Beneficiado',
    application: 'Aplicación',
    first_interaction: 'Primera interacción',
    last_interaction: 'Última interacción',
    table_project: 'Proyecto de la tabla',
    table_dataset: 'Dataset de la tabla',
    view_project: 'Proyecto de la vista',
    view_dataset: 'Dataset de la vista',
    view: 'Vista',
    data_operator: 'Operador',
    user: 'Usuario',
    groups: 'Grupos',
    user_inca: 'Usuario INCA',
    user_pbi: 'Usuario PBI',
    name: 'Nombre',
    created_by: 'Creado por',
    type: 'Tipo',
    domain: 'Dominio',
    user_roles: 'Roles de usuario',
    user_email: 'Correo de usuario',
    tags: 'Etiquetas(clasificación)',
    aka: 'También conocido como',
    accountable: 'Responsable',
    critical: '¿Crítico? (Y/N)',
    position: 'Cargo',
    supervisor: 'Supervisor',
    months: 'Meses',
    project: 'Proyecto',
    dataset: 'Dataset',
    creator: 'Creador',
    description: 'Descripción',
    capacity: 'Capacidad',
    object: 'Objeto',
    object_type: 'Tipo de objeto',
    response_date: 'Fecha de respuesta',
    end_date: 'Fecha Fin',
    weight: 'Peso',
    field_type: 'Tipo de campo',
    table_type: 'Tipo de tabla',
    lower: 'Inferior',
    upper: 'Superior',
    bterm_definition: 'Definición de Negocio',
    validation_type: 'Tipo de validación',
    thresholds: 'Umbrales',
    primary_key: 'Llave primaria',
    priority: 'Prioridad',
    partition: 'Partición',
    dimension: 'Dimensión',
    version: 'Versión',
    frequency: 'Frecuencia de ejecución',
    upper_th: 'Umbral superior',
    lower_th: 'Umbral inferior',
    table_filter: 'Filtro de tabla*',
    specification: 'Especificación',
    start_date: 'Fecha de inicio',
    execution_id: 'ID de ejecución',
    execution_date: 'Fecha de ejecución',
    id_detail: 'Detalle de ID',
    rule_id: 'ID de regla',
    rule_code: 'Código de regla',
    rule_name: 'Nombre de regla',
    element_type: 'Tipo de elemento',
    element_name: 'Nombre de elemento',
    element_description: 'Descripción de elemento',
    config_name: 'Nombre de configuración',
    field: 'Campo',
    sample_value: 'Valor de muestra',
    partition_ini: 'Inicio de partición',
    partition_end: 'Fin de partición',
    flag_priority: 'Indicador de prioridad',
    flag_pk: 'PK de indicador',
    load_date: 'Fecha de carga',
    creation_user: 'Usuario creador',
    itc_id: 'ID de compañía ITC',
    itc_name: 'Nombre de compañía ITC',
    data_type: 'Tipo de dato',
    nullability: 'Nulabilidad',
    no_null: '% no nulos',
    q_no_null: 'C no nulos',
    q_null: 'C nulos',
    empty: 'Vacío',
    empty_space: '% Espacio vacío',
    q_empty_space: 'C Espacio vacío',
    unicity: 'Unicidad',
    unique_value: '% Valores únicos',
    numerical: 'Numérico',
    numeric: '% Numérico',
    q_no_numeric: 'C no numérico',
    freq: 'Frecuencia',
    q_freq_value: 'C Valor frecuente',
    most_freq_value: 'Valor más frecuente',
    length: 'Longitud',
    max_length: 'Longitud máxima',
    log_time: 'Fecha de registro',
    method: 'Método',
    message: 'Mensaje',
    workspace: 'Espacio de trabajo',
    relationship: 'Relación',
    related_term: 'Término relacionado',
    record_source: 'Origen de registro',
    observation: 'Observación'
  },
  search: {
    all_results: 'Todos los resultados',
    change: 'Cambiar',
    clean: 'Limpiar',
    coincidences: 'Coincidencias',
    continue_filtering: 'Para seguir filtrando el botón de la derecha',
    description: 'Descripción',
    domain: 'Dominio',
    found_in: 'Encontrado en',
    no_results: 'No se han encontrado resultados para tu búsqueda',
    stats_title: 'Métricas de uso (últimos 30 días)',
    stats_queries_30d: 'Consultas',
    stats_users_30d: 'Usuarios distintos',
    stats_last_queried_at: 'Última consulta',
    stats_last_queried_by: 'Último consultante',
    stats_empty: 'Sin consultas registradas en los últimos 30 días',
    stats_computed_at: 'Datos al {fecha}',
    object_type: 'Tipo de Objeto',
    request: 'Solicitar',
    search: 'Buscar',
    search_filters: 'Filtros de búsqueda',
    seconds: 'segundos',
    text: 'Texto',
    view: 'Ver'
  },
  data_management: {
    placeholder: {
      organization: 'Organización',
      project: 'Proyecto',
      dataset: 'Dataset',
      table: 'Tabla'
    },
    label: {
      organization: 'Organización',
      project: 'Buscar por proyecto',
      dataset: 'Buscar por dataset',
      table: 'Buscar por tabla'
    }
  },
  data_estrategy: {
    title_evaluation_report: 'Assessment de Madurez Analítica',
    subtitle_evaluation_report: 'Subtitulo Assessment de Madurez Analítica',
    title_manage_evaluation_report: 'Assessment de Madurez Analítica',
    subtitle_manage_evaluation_report: 'Mantenimiento de Assessment'
  },
  log_power_bi: {
    title: 'Informe de auditoría de uso en Power BI',
    subtitle: '',
    title_manage_report: 'Mantenimiento - Informe de auditoría de uso en Power BI',
    subtitle_manage_report: ''
  },
  monitoring_billing: {
    title: 'Reportes de Monitoreo',
    title_reports: 'Monitoreo y Facturación',
    subtitle: 'Mantenimiento de reportes de indicadores',
    name: 'Nombre',
    description: 'Descripción',
    maintenance: 'Mantenimiento',
    reports_desc: 'Reportes de Monitoreo y Facturación'
  },
  attributes: {
    button: {
      search: 'Buscar',
      confirm: 'Confirmar',
      back: 'Anterior',
      add_base: 'Agregar base',
      finalize: 'Finalizar',
      register_selection: 'Guardar selección',
      clean_selection: 'Limpiar selección',
      register: 'Registrar',
      edit: 'Editar',
      view_detail: 'Ver detalle',
      add: 'Agregar',
      by_word: 'Por palabra',
      by_group: 'Por grupo'
    },
    label: {
      search: 'Buscar',
      category: 'Categoría',
      pct_not_null_without_value: '% no nulo sin valor',
      include_search_by_desc: 'Incluir búsqueda por nombre y descripción',
      semantic_search: 'Búsqueda semántica',
      include_search_by_extra_data: 'Incluir búsqueda por datos adicionales',
      use_case_name: 'Nombre del caso de uso',
      duration: 'Duración de sandbox',
      detail_use_case: 'Detalle del caso de uso',
      add_sa_by_business_area: 'Agregar cuenta de servicio según área de negocio',
      users: 'Usuario nuevo',
      register_group_text: 'Registra tu grupo de atributos seleccionados, el cual podrás usarlo en los diferentes sandbox que solicites',
      title_view_attributes: 'Grupo de Atributos',
      my_custom_groups: 'Mis grupos de atributos',
      this_is_the_list_attributes: 'Este es el listado de los grupos de atributos que has registrado',
      name_es: 'Nombre (es)',
      name_en: 'Nombre (en)',
      group_date: 'Fecha de registro',
      description_es: 'Descripción (es)',
      description_en: 'Descripción (en)',
      attribute_object_name: 'Objeto',
      attribute_scheme_name: 'Esquema',
      attribute_project_name: 'Proyecto',
      alias: 'Alias',
      icon: 'Subir imagen',
      group_name: 'Nombre de grupo',
      group_description: 'Descripción',
      total_records: 'Total de registros',
      has_not_party_match: 'No tiene registrado un filtro'
    },
    placeholder: {
      input_user: 'Ingresar email de usuario nuevo que deseas agregar',
      use_case: 'Filtrar por caso de uso',
      input_segment: 'Ingresa el nombre del segmento',
      select_process_date: 'Seleccionar fecha de proceso',
      attach_script_sql_txt: 'Selecciones archivo (.sql, .txt)'
    },
    discover_attributes: 'Descubre los atributos de las empresas del grupo',
    search: {
      title: 'titulo',
      search: 'búsqueda de atributos',
      corporate: 'Corporativos',
      demographics: 'Demográficos',
      digital: 'Digitales',
      Retail: 'Retail',
      RCC: 'RCC',
      payments: 'Pagos',
      insurance: 'Seguros',
      custom_attributes: 'Mis grupos',
      for_a_keyword: 'Buscar una palabra clave',
      select_an_attribute: 'Selecciona una categoría de atributos',
      user_groups_title: 'Atributos creados por el usuario',
      user_groups_empty: 'No hay categorías creadas por el usuario para esta empresa.',
      user_groups_select_company: 'Selecciona una empresa',
      user_groups_no_companies: 'No hay empresas disponibles.',
      user_groups_company_breadcrumb: 'Empresas',
      user_groups_only_with_content: 'Mostrar solo empresas con categorías',
      table_search_list: {
        name: 'Nombre',
        description: 'Descripción',
        data_type: 'Tipo',
        category: 'Categoría',
        percentage: '% no nulo',
        additional_data: 'Datos Adicionales',
        actions: {
          title: 'Acciones',
          see_report: 'Ver reporte',
          add_ids: 'Añadir Base INCA',
          add_attrs: 'Añadir atributos',
          go_sandbox: 'Ir a Sandbox'
        }
      }
    },
    attributes_description: {
      corporate: 'Atributos a nivel corporativo de los clientes del Grupo Intercorp.',
      demographics: 'Atributos demográficos de los clientes del Grupo Intercorp provenientes de la tabla m_customer.',
      digital: 'Atributos basados en el comportamiento del cliente en el canal digital. Sesiones, eventos, intensiones de comprar, etc.',
      Retail: 'Atributos del perfil de los clientes en las empresas Retail (Supermercados Peruanos, Farmarcias Peruanas, Oechsle, Promart).',
      RCC: 'Atributos del perfil de los clientes en el Reportes Crediticios Consolidados.',
      payments: 'Atributos basados en los pagos generados con las tarjetas de crédito Oh y tarjeta Agora de los clientes del Grupo Intercorp.',
      insurance: 'Atributos basados en la relación e interacción con los productos y servicios de Interseguro.',
      custom_attributes: 'Agrupaciones de atributos creados por los usuarios de la organización enfocados en un caso de uso específico.',
      not_identified_ids: 'IDs que no se encuentran registrados en Intercorp.'
    },
    group: {
      name: 'Nombre',
      definition: 'Definición',
      quantity: 'Cantidad',
      owner: 'Propietario'
    },
    sandbox: {
      request_title: 'Solicitud de creación de sandbox',
      request_subtitle: 'Completa y/o confirma cada fase para enviar tu solicitud',
      attribute_selection: 'Selección de Attributos',
      confirm: 'Confirma tu selección o sigue agregando todos los atributos que necesitarás para tu caso de uso',
      this_is_add: 'Este será añadido a tu sandbox',
      quantity_attributes: 'Cantidad de atributos seleccionados',
      request: 'Solicitud',
      complete_form: 'Completa el formulario de solicitud de creación de sandbox para poder registrar el caso de uso que realizarás',
      add_base_ids: 'Añadir base IDs',
      select_equivalent: 'Selecciona el equivalente al party_id, asi como las variables que necesitarias de la tabla. Recuerda que esta tabla tendrá que estar publicada en INCA',
      list_base_adds: 'Lista de bases agregadas',
      productize_model_desc: ''
    },
    error: {
      required: 'No attributes selected'
    },
    managment: {
      attribute_master_title: 'Maestro de Atributos',
      attribute_master_subtitle: 'Mantenimiento de maestro de atributos',
      modal_add_attribute_master: 'Nueva categoría de atributos',
      modal_edit_attribute_master: 'Editar categoría de atributos',
      metrics: 'Metrics',
      manage_metrics: 'Mantenimiento de reporte de métricas',
      headers: {
        category: 'Categoría',
        description: 'Descripción',
        table: 'Tabla Inca'
      },
      button: {
        create: 'Nuevo'
      },
      label: {
        add: 'Aquí se podrá registrar una nueva categoría de atributos. Será necesario el nombre, la descripción y el logo que luego se mostrará en el menú de búsqueda. Recuerda que se deberá enlazar con una tabla que ya se encontrará actualizada en el módulo Data Management',
        black_list: 'Aquí se podrá seleccionar los atributos que se desean ocultar, como campos de auditoría, fecha de carga o campos de calidad',
        search_list: 'Buscar atributos',
        selected_list: 'Atributos no visibles'
      }
    }
  },
  customer_insights: {
    label: {
      somos1_data_entry: 'Entrada de datos',
      somos1_data_entry_desc: 'Sube los indicadores financieros y operacionales de tu organización',
      somos1_v2_regional_1_title: 'Somos 1 v2 - Indicadores regionales 1',
      somos1_v2_regional_1_desc: 'Visualiza los indicadores regionales 1 de Somos 1 v2',
      somos1_v2_regional_2_title: 'Somos 1 v2 - Indicadores regionales 2',
      somos1_v2_regional_2_desc: 'Visualiza los indicadores regionales 2 de Somos 1 v2',
      somos1_reports: 'Visualiza tus reportes asignados con información de la Vista Única del Cliente Intercorp',
      somos1_data_entry_report: 'Visualiza los reportes "Somos 1" a los que tienes acceso',
      hand_upload: 'Carga manual',
      bulk_upload: 'Carga masiva',
      organization: 'Organización',
      tipo_reporte: 'Opción',
      indicator: 'Indicador',
      year: 'Año',
      month: 'Mes',
      forecast: 'Forecast',
      brand: 'Marca',
      region: 'Region',
      general_indicators: 'Indicadores generales',
      visitor_presentation: 'Presentación para visitas',
      visitor_presentation_sub: 'Te enseñamos qué campos de tu plantilla de empresa debes completar',
      complete_template: 'Recuerda que esta plantilla solo podrás completarla una vez cada mes',
      visitor_step1: 'Paso 1: Hightlights',
      visitor_step2: 'Paso 2: Competidores',
      visitor_step3: 'Paso 3: Métricas',
      tracking_dataentry: 'Seguimiento de Data Entry',
      tracking_dataentry_sub: 'Te mostramos el estado de la carga de Data Entry',
      view_info: 'Ver información',
      info: 'Información',
      last_info_updated: 'La última información que aparece en el reporte fue subida por:',
      last_info_date: 'Fecha de última actualización:'
    },
    button: {
      filter: 'Filtrar',
      download: 'Descargar',
      download_log: 'Historial',
      send: 'Enviar'
    },
    rules: {
      organization: 'Seleccione una empresa',
      brand: 'Seleccione una marca',
      indicator: 'Seleccione un indicador',
      year: 'Seleccione un Año',
      month: 'Seleccione un Mes',
      forecast: 'Seleccione una opción',
      file: 'Seleccione un archivo',
      file_size: 'El archivo es demasiado grande',
      tipo_reporte: 'Seleccione una opción'
    },
    bulk_upload: {
      title: 'KPIs mensuales',
      sub_title: 'Completa correctamente la información requerida',
      drag_here: 'Arrastra y suelta aquí',
      search_computer: 'busca en tu ordenador',
      download_it_now: 'Si no cuentas aún con la plantilla puedes descargarla ahora',
      template: 'Plantilla',
      budget_upload_btn: 'Presupuesto'
    },
    forecast: {
      title: 'Forecasts',
      upload_btn: 'Forecast'
    },
    data_entry: {
      header: {
        year: 'año',
        city: 'ciudad',
        january: 'enero',
        february: 'febrero',
        march: 'marzo',
        april: 'abril',
        may: 'mayo',
        june: 'junio',
        july: 'julio',
        august: 'agosto',
        september: 'setiembre',
        october: 'octubre',
        november: 'noviembre',
        december: 'diciembre'
      }
    }
  },
  dataops: {
    orchestrator: 'Orquestador',
    import_script: 'Importar script',
    job_executions_history: 'Historial de ejecuciones de Jobs'
  },
  chatbots_translations: {
    wizard: {
      title: 'Conexión WebSite Chat',
      description: 'Comience a configurar con la configuración básica.',
      additional_resources: 'Recursos Adicionales'
    },
    channel: {
      title: 'Canales',
      description: 'Administre sus canales de mensajería y descubra otros nuevos que le ayudarán a adquirir más clientes.'
    },
    channel_catalog: {
      title: 'Channels Catalog',
      description: 'Administre sus canales de mensajería y descubra otros nuevos que le ayudarán a adquirir más clientes.'
    }
  },
  user_access: {
    module: 'MÓDULO',
    history: 'HISTÓRICO',
    last_3_month: 'ÚLTIMOS 3 MESES',
    current_month: 'MES ACTUAL',
    title: 'Historial de inicios de sesión',
    subtitle: 'Historial de usuarios que accedieron a Inca',
    email: 'Correo electrónico',
    domain: 'Dominio'
  },
  help_center: {
    help_center: 'Centro de ayuda',
    hello: '¡Hola!,¿cómo podemos ayudarte?',
    question: 'Escribe tu consulta',
    comunicate: 'Comunícate con nostros',
    description: 'Descripción',
    functionalities: 'Funcionalidades principales',
    gterms: 'Glosario de términos',
    manual: 'Manual de uso',
    type: 'Tipo',
    section: '¿En qué sección de INCA?',
    details: 'Detalles',
    comments: 'Comentarios adicionales(opcional)',
    module: 'Módulo',
    responsible: 'Responsable',
    title: 'Título',
    informant: 'Informante',
    date: 'Fecha',
    news: 'Novedades',
    read: 'Lee y Aprende',
    videos: 'Videos Tutoriales',
    sugerences: 'Sugerencias',
    feedback: 'Comentarios',
    sugerence_alert: 'Tu opinión es importante para mejorar INCA Platform. Recuerda completar todos los apartados para poder conocer tus ideas.'
  },
  crud: {
    View: 'Ver',
    Edit: 'Editar',
    Create: 'Crear',
    Delete: 'Eliminar'
  },
  ownership_requests: {
    tabs: {
      sandbox: 'Sandbox',
      create_attribute: 'Crear Atributo'
    },
    create_attribute: {
      use_case: 'Caso de uso',
      table_name: 'Nombre de tabla',
      periods: 'Periodos',
      date: 'Fecha',
      operator: 'Operador',
      review: 'Revisar'
    },
    review_dialog: {
      title: 'Revisar solicitud de Crear Atributo',
      script_label: 'Script SQL editable',
      revalidate: 'Volver a validar con IA',
      approve: 'Aprobar y ejecutar',
      reset_script: 'Restaurar script',
      edited_badge: 'Editado',
      lines_label: '{count} líneas',
      validation_status_ok: 'Validación correcta',
      validation_status_error: 'Con observaciones',
      validation_status_unknown: 'Pendiente de validar',
      reason_label: 'Motivo de aprobación (opcional)',
      revalidate_ok: 'La validación pasó correctamente.',
      revalidate_still_failing: 'La validación sigue mostrando observaciones.',
      approve_success: 'Solicitud aprobada. El pipeline fue iniciado.',
      validation_ok: 'La validación de particiones pasó correctamente.',
      script_error: 'No se pudo cargar el script almacenado.',
      script_empty: 'El script SQL no puede estar vacío.',
      missing_original_data: 'No se pudo recuperar la información original de la solicitud.',
      no_validation: 'No hay resultado de validación registrado para esta solicitud.'
    }
  },
  create_attribute: {
    title: 'Crear Atributo',
    new_automation: 'Nueva automatización',
    review: {
      sent_title: 'Enviado a revisión',
      sent_message: 'La validación de particiones encontró observaciones. La automatización quedó en estado Solicitado para revisión de un administrador.'
    },
    table: {
      company: 'Empresa',
      status: 'Estado',
      created_date: 'Fecha Creación',
      use_case: 'Caso de Uso',
      table_name: 'Nombre de Tabla',
      owner: 'Creador'
    },
    headers: {
      status: 'Estado'
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
      processing: 'En proceso',
      error: 'Error',
      pending: 'Pendiente',
      completed: 'Completado',
      solicitado: 'Solicitado',
      en_ejecucion: 'En ejecución',
      ejecutado: 'Ejecutado',
      desactivo: 'INACTIVO'
    },
    filters: {
      company: 'Empresa',
      status: 'Estado',
      all_statuses: 'Todos los estados',
      use_case: 'Caso de Uso',
      date: 'Fecha',
      table_name: 'Nombre de tabla'
    },
    sections: {
      basic_info: 'Información básica',
      sql_script: 'Script SQL'
    },
    form: {
      script_file: 'Archivo de script (SQL)',
      month: 'Mes',
      year: 'Año',
      periods: 'Periodos',
      add_period: 'Agregar',
      use_case: 'Caso de Uso',
      drag_file: 'Arrastra tu archivo aquí',
      or: 'o',
      attach_file: 'Adjuntar archivo',
      async_info: 'El proceso de creación puede demorar hasta 5 minutos. Se le notificará cuando esté completo.',
      table_description: 'Descripción de la tabla',
      table_description_placeholder: 'Describa brevemente el propósito y contenido de la tabla de atributos...',
      nombre_tabla: 'Nombre de tabla',
      nombre_tabla_hint: 'Solo minúsculas, números y guiones bajos (3-63 caracteres). Ej: segmentacion_premium'
    },
    rules: {
      file_required: 'El archivo es requerido',
      description_required: 'La descripción es requerida',
      description_max_length: 'La descripción no puede exceder 500 caracteres',
      file_size: 'El archivo no debe exceder 5MB',
      month_required: 'El mes es requerido',
      year_required: 'El año es requerido',
      use_case_required: 'El caso de uso es requerido',
      period_required: 'Debes agregar al menos un periodo',
      period_duplicate: 'Este periodo ya fue agregado',
      max_periods: 'Máximo {max} periodos permitidos',
      nombre_tabla_required: 'El nombre de tabla es requerido',
      nombre_tabla_format: 'Solo letras minúsculas, números y guiones bajos. Debe empezar con letra (3-63 caracteres)',
      nombre_tabla_duplicate: 'Ya existe una automatización con ese nombre de tabla. Elige otro.',
      load_months_pending_review: 'Esta automatización está pendiente de aprobación. Debe aprobarse en "Gestionar solicitudes" antes de cargar meses.'
    },
    errors: {
      select_period: 'Selecciona entre 1 y 12 periodos',
      invalid_file_type: 'Solo se permiten archivos .sql',
      table_not_ready: 'La tabla aún no está disponible',
      timeout: 'La creación tomó demasiado tiempo. Verifica la tabla y reintenta si es necesario.'
    },
    partition_validation: {
      outside_db: 'Tabla "{table}" no pertenece a la base esperada ("{expected}").',
      missing_filter: 'Tabla "{table}" está particionada. Agrega un filtro WHERE por al menos una de estas columnas: {cols}.',
      blocked: 'El SQL no pasó la validación de particiones. Corrige los problemas indicados.',
      panel_title: 'El SQL no pasó la validación de particiones',
      panel_subtitle: 'Corrige los siguientes problemas en el script y vuelve a validar.',
      partition_column: 'Columna de partición',
      line: 'Línea {n}',
      detected_code: 'Código detectado',
      why_fails: 'Por qué falla',
      how_to_fix: 'Cómo corregir',
      copy: 'Copiar',
      copied: 'Copiado al portapapeles',
      no_suggestion: 'Sin sugerencia disponible'
    },
    success: {
      created: 'Automatización creada exitosamente. El proceso se ejecutará en segundo plano.',
      months_loaded: 'Carga de meses iniciada exitosamente',
      deactivated: 'Automatización desactivada exitosamente'
    },
    dialogs: {
      new_automation: 'Nueva Automatización',
      created_title: 'Éxito',
      created_activity_text: 'Automatización creada exitosamente. ¿Quieres ver la actividad del proceso?',
      created_activity_yes: 'Ver actividad',
      created_activity_no: 'Cerrar',
      load_months_started_title: 'Carga iniciada',
      load_months_activity_text: 'Carga de meses iniciada exitosamente. ¿Quieres ver la actividad del proceso?',
      detail: 'Detalle de Atributo',
      history: 'Historial de Cargas',
      load_months: 'Cargar Meses',
      edit_script: 'Editar Script',
      deactivate_title: 'Desactivar automatización',
      deactivate_text: '{name} deja de cargarse cada mes y sale de Buscar atributos. La tabla y sus datos se conservan, así que los sandboxes que ya la usan siguen funcionando. Hoy no se puede reactivar desde la plataforma.',
      deactivate_yes: 'Desactivar',
      deactivate_this: 'Esta automatización',
      deactivate_no: 'Cancelar',
      change_status_title: 'Cambiar estado',
      hard_delete_title: 'Eliminar definitivamente',
      share: 'Compartir automatización'
    },
    detail: {
      tables_section: 'Tablas generadas',
      gcp_table: 'Tabla en Gestión de Datos',
      model_table: 'Tabla modelo BigQuery (S3 → GCS)',
      aws_table: 'Tabla modelo BigQuery (S3 → GCS)',
      aws_output_table: 'Tabla de salida (AWS)',
      operator: 'Operador',
      executions_tab: 'Ejecuciones',
      executed_periods: 'Períodos ejecutados',
      periods_tab: 'Períodos',
      download_script: 'Descargar script original',
      download_script_error: 'No se pudo descargar el script original'
    },
    history: {
      no_records: 'No hay registros de historial',
      period: 'Período',
      start_date: 'Fecha Inicio',
      end_date: 'Fecha Fin',
      status: 'Estado'
    },
    activity_timeline: {
      title: 'Actividad de la automatización',
      empty: 'No hay ejecuciones registradas todavía.',
      load_more: 'Cargar más',
      periods: 'periodos',
      retry: 'Reintentar',
      retry_all: 'Reintentar paso ({count})',
      retry_from_step: 'Reintentar desde el paso {step}',
      retry_success: 'Paso reintentado exitosamente',
      retry_error: 'Error al reintentar el paso',
      incremental_note: 'Carga incremental: se copian solo los periodos seleccionados de S3 a GCS, se recarga la tabla modelo BigQuery y se reemplazan esos periodos en la tabla final. Catálogo, IA y Typesense ya están sincronizados desde la creación inicial.',
      aws_timeline_title: 'Flujo AWS detallado',
      types: {
        creation: 'Creación inicial',
        edit_script: 'Edición de script',
        load_months: 'Carga incremental'
      },
      overall: {
        success: 'Completada',
        partial_failure: 'Con errores',
        in_progress: 'En ejecución'
      },
      status: {
        pending: 'Pendiente',
        in_progress: 'En progreso',
        success: 'Completado',
        failed: 'Error',
        skipped: 'Omitido',
        unknown: 'Desconocido'
      },
      steps: {
        aws_pipeline: 'Ejecución AWS (Athena/Glue)',
        duplicate_attribute_validation: 'Validación de atributos duplicados',
        bq_dts_table: 'Carga modelo S3 → GCS → BigQuery',
        bq_omni_table: 'Tabla BigQuery OMNI (legacy)',
        create_attribute_table: 'Materialización tabla final',
        validate_attribute_table: 'Validación tabla materializada',
        ai_column_metadata: 'Metadata de Columnas (IA)',
        data_catalog_sync: 'Sincronización Data Catalog',
        create_category: 'Crear Categoría',
        typesense_sync: 'Sincronizar Typesense'
      }
    },
    actions: {
      view_detail: 'Ver detalle',
      view_activity: 'Ver actividad',
      load_months: 'Cargar meses',
      edit_script: 'Editar script',
      deactivate: 'Desactivar',
      update_metadata: 'Actualizar metadata',
      change_status: 'Cambiar estado',
      hard_delete: 'Eliminar definitivamente',
      share: 'Compartir automatización',
      row_menu: 'Acciones de {name}'
    },
    shared_badge: 'Compartida',
    share_info: 'Los usuarios compartidos pueden ver el detalle, actividad, cargar meses y desactivar.',
    share_empty: 'Nadie más tiene acceso a esta automatización todavía.',
    share_revoke_confirm: '¿Quitar acceso a {email}?',
    change_status: {
      warning: 'Solo corrige el estado registrado. No relanza el pipeline ni el post-pipeline: si faltan pasos por ejecutar, usa el reintento por paso en "Ver actividad".',
      target_label: 'Tabla',
      current_label: 'Estado actual',
      new_label: 'Nuevo estado',
      reason_label: 'Motivo del cambio',
      reason_hint: 'Indica por qué cambias el estado manualmente (entre 10 y 500 caracteres).',
      reason_required: 'El motivo es obligatorio.',
      reason_min: 'El motivo debe tener al menos 10 caracteres.',
      reason_max: 'El motivo no puede superar los 500 caracteres.',
      confirm_btn: 'Cambiar estado',
      success: 'Estado cambiado correctamente.',
      rejected: 'El backend rechazó el cambio de estado.',
      not_allowed: 'El estado actual no admite cambio manual.'
    },
    hard_delete: {
      // Borrado definitivo v2 (2026-10-01): una columna, fricción según lo que se pierde.
      dialog_heading: 'Eliminar definitivamente el atributo',
      close_label: 'Cerrar sin eliminar',
      meta: 'Caso de uso: {use_case} · Estado: {status} · ID {id}',
      cannot_undo: 'No se puede deshacer.',
      desc_nothing: 'No llegó a cargar datos: se borra el registro y su script, y el nombre de la tabla queda libre.',
      desc_data: 'Se borrarán la tabla y sus datos en BigQuery, AWS y Cloud Storage, y el atributo dejará de aparecer en Buscar atributos.',
      desc_consumers: 'Se borrarán la tabla y sus datos en BigQuery, AWS y Cloud Storage, y el atributo dejará de aparecer en Buscar atributos. Quienes lo usan en sus casos de uso perderán acceso.',
      impact_title: 'Qué se pierde',
      preview_loading: 'Consultando qué se eliminará…',
      preview_error_title: 'No pudimos consultar qué se eliminará.',
      preview_error_text: 'Sin este detalle no ves si alguien usa el atributo.',
      preview_retry: 'Reintentar la consulta',
      preview_ack: 'Eliminar sin ver el detalle',
      preview_ack_hint: 'La consulta volvió a fallar. Si continúas, el borrado sigue igual, pero no sabrás a quién afecta.',
      tag_breaks: 'SE ROMPE',
      tag_unconfirmed: 'SIN CONFIRMAR',
      tag_lost: 'NO SE RECUPERA',
      tag_stops: 'SE DETIENE',
      tag_hidden_too: 'TAMBIÉN SE OCULTA',
      tag_platform: 'SE QUITA DE INCA',
      tag_config: 'CONFIGURACIÓN',
      tag_none: 'SIN DATOS',
      tag_kept: 'SE CONSERVA',
      tag_untouched: 'NADA QUE BORRAR',
      consumers_title: '{n} caso de uso usa estos atributos | {n} casos de uso usan estos atributos',
      consumers_text: 'Sus sandboxes dejan de ver estos atributos en cuanto se borre la tabla.',
      consumers_toggle: 'Ver cuáles',
      consumers_more: 'y {n} más',
      consumers_unknown_title: 'No se pudo comprobar quién usa estos atributos',
      consumers_unknown_text: 'Si continúas, el borrado sigue igual, pero puede romper casos de uso que no ves aquí.',
      consumer_ref: 'Caso de uso {id} · empresa {company}',
      consumer_active: 'Vigente hasta {date}',
      consumer_expired: 'Vencido el {date}',
      consumer_other: 'Hasta {date}',
      runs_title: 'Hay una carga en curso',
      runs_text: 'Se cancela la ejecución de Step Functions y Glue que está corriendo.',
      data_title: 'Datos y catálogo · {n} recurso | Datos y catálogo · {n} recursos',
      data_toggle: 'Ver detalle técnico',
      siblings_title: '{n} tabla más deja de verse en Buscar atributos | {n} tablas más dejan de verse en Buscar atributos',
      siblings_text: 'Comparten la categoría “{alias}” con esta tabla. No se borran, pero el buscador las oculta juntas.',
      siblings_toggle: 'Ver cuáles',
      platform_title: 'Sale de Buscar atributos y de Gestión de Datos',
      platform_text: 'Se oculta del buscador, se cancela su flujo de aprobación y se borra su ficha de metadata.',
      config_title: 'Este ambiente tiene un problema de configuración',
      config_text: 'Algunos pasos no se podrán completar. Avisa al equipo de plataforma.',
      config_toggle: 'Ver el detalle',
      none_title: 'No hay tablas ni datos que borrar',
      none_text: 'Se borra el script guardado y el registro queda como eliminado.',
      kept_title: 'Auditoría',
      kept_text: 'Tu motivo, quién lo eliminó y el historial de cargas.',
      untouched_title: '{n} paso sin nada que borrar | {n} pasos sin nada que borrar',
      untouched_toggle: 'Ver por qué',
      retention_note: 'Se retiene {days} día(s) · purga estimada {date}',
      alternative_title: '¿Solo quieres que deje de cargarse?',
      alternative_text: 'Desactívalo: deja de cargarse cada mes y sale del buscador, pero la tabla y sus datos se conservan y no rompe a quienes ya lo usan.',
      alternative_btn: 'Desactivar en su lugar',
      confirm_title: 'Confirma la eliminación',
      reason_label: 'Motivo de la eliminación',
      reason_hint: 'Entre 10 y 500 caracteres. Queda en la bitácora de auditoría.',
      reason_min: 'Escribe al menos 10 caracteres.',
      name_instruction: 'Para confirmar, escribe {name}',
      name_label: 'Nombre de la tabla',
      name_mismatch: 'No coincide con el nombre de la tabla.',
      force_label: 'Detener la carga en curso',
      force_hint: 'Se cancela la ejecución de Step Functions y Glue que está corriendo.',
      ack_consumers: 'Entiendo que {n} caso de uso perderá acceso a estos atributos | Entiendo que {n} casos de uso perderán acceso a estos atributos',
      ack_consumers_unknown: 'Entiendo que no se pudo comprobar quién usa estos atributos',
      confirm_btn: 'Eliminar atributo definitivamente',
      retry_btn: 'Reintentar eliminación',
      sending_btn: 'Eliminando…',
      sending_hint: 'Eliminando… no cierres esta ventana.',
      sending_escape: 'La eliminación está en curso. Espera a que termine.',
      missing_prefix: 'Para continuar:',
      missing_and: 'y',
      missing_preview_loading: 'espera a que termine la consulta',
      missing_preview_retry: 'reintenta la consulta de lo que se eliminará',
      missing_preview_ack: 'confirma que eliminas sin ver el detalle',
      missing_reason: 'escribe el motivo (mínimo 10 caracteres)',
      missing_name: 'escribe el nombre exacto de la tabla',
      missing_force: 'marca “Detener la carga en curso”',
      missing_ack: 'confirma que entiendes a quién afecta',
      missing_in_progress: 'espera a que termine la otra eliminación',
      progress_title: 'Progreso',
      progress_step: 'Paso {current} de {total}: {label}',
      checklist_title: 'Pasos del intento',
      checklist_hint: 'Al reintentar se retoma desde el primer paso que falló; lo que ya se borró no se repite.',
      hidden_steps: 'y {n} paso sin nada que borrar | y {n} pasos sin nada que borrar',
      state_done: 'Listo',
      state_run: 'En curso',
      state_wait: 'Pendiente',
      state_fail: 'Falló',
      state_skip: 'Se omitirá',
      state_skipped: 'Omitido',
      state_none: 'Nada que borrar',
      skip_label: 'Omitir este paso (quedará pendiente de limpieza manual)',
      skip_blocked: 'No se puede omitir: el atributo quedaría como eliminado con sus datos todavía en AWS o en la base.',
      skip_warning: 'Los pasos omitidos no se ejecutan: lo que limpian queda pendiente de hacerse a mano, pero el atributo igual queda eliminado y libera el nombre de la tabla.',
      outcome_success: 'Se eliminó {name}. El nombre de la tabla ya se puede reutilizar.',
      outcome_already: '{name} ya estaba eliminado.',
      outcome_partial_title: 'La eliminación quedó a medias.',
      outcome_partial_text: 'Terminaron {done} de {total} pasos. Falló “{step}”: {detail}',
      outcome_partial_action: 'Reintenta: se retoma desde ese paso. Si vuelve a fallar en el mismo paso, comparte el detalle con el equipo de plataforma. El nombre de la tabla sigue reservado hasta que termine.',
      outcome_partial_glue_action: 'Reintenta. Si vuelve a fallar, falta el permiso de borrado (DROP) en la cuenta dueña del catálogo Glue: lo otorga el equipo del data lake.',
      outcome_partial_dataplex_action: 'Reintenta. Si vuelve a fallar, el usuario operador no tiene rol de steward en Gestión de Datos. Si urge, puedes omitir este paso: la ficha de metadata quedará para borrarla a mano.',
      outcome_in_progress_title: 'Otra persona ya está eliminando este atributo.',
      outcome_in_progress_text: 'La eliminación la inició {who} a las {time}. Espera a que termine; si no avanza, podrás retomarla desde las {retry_time}.',
      outcome_in_progress_btn: 'Ver el estado de esa eliminación',
      outcome_force_title: 'La automatización empezó a cargar mientras confirmabas.',
      outcome_force_text: 'Marca “Detener la carga en curso” y vuelve a intentarlo.',
      outcome_forbidden_title: 'Tu usuario no puede eliminar atributos.',
      outcome_forbidden_text: 'Hace falta el rol de administrador de atributos. Pídelo a un administrador de la plataforma.',
      outcome_not_found_title: 'Esta automatización ya no existe.',
      outcome_not_found_text: 'Cierra este diálogo y actualiza el listado.',
      outcome_not_v2_title: 'Este atributo no se puede eliminar desde aquí.',
      outcome_not_v2_text: 'Solo se eliminan definitivamente los atributos creados con Crear Atributo.',
      outcome_transition_title: 'El estado de la automatización cambió mientras confirmabas.',
      outcome_transition_text: 'Cierra este diálogo, actualiza el listado y vuelve a intentarlo.',
      outcome_error_title: 'No se pudo terminar la eliminación.',
      outcome_error_text: 'El servidor respondió con un error. Puede que una parte ya se haya borrado.',
      outcome_error_action: 'Reintenta: el borrado retoma desde donde quedó. Si el error se repite, avisa al equipo de plataforma.',
      what_to_do: 'Qué hacer:',
      groups: {
        data: 'Datos y catálogo',
        runs: 'Ejecuciones en curso',
        platform: 'Plataforma INCA'
      },
      steps: {
        stepfunctions_stop: 'Cancelar la ejecución de Step Functions',
        glue_runs_stop: 'Detener las ejecuciones de Glue',
        dynamodb_dedupe_delete: 'Borrar el control de duplicados (DynamoDB)',
        s3_lambda_cache_delete: 'Borrar el script SQL en S3',
        s3_pending_script_delete: 'Borrar el script de la solicitud en S3',
        glue_get_table_location: 'Ubicar la tabla en el catálogo Glue',
        s3_parquet_delete: 'Borrar los datos Parquet en S3',
        glue_delete_table: 'Borrar la tabla del catálogo Glue',
        athena_staging_drop: 'Borrar las tablas temporales en Athena',
        athena_staging_preserved: 'Tablas con prefijo similar que NO se tocarán',
        dataplex_metadata_delete: 'Borrar la ficha de metadata en Gestión de Datos',
        bq_drop_final: 'Borrar la tabla final en BigQuery',
        bq_drop_temps: 'Borrar las tablas temporales en BigQuery',
        gcs_scripts_delete: 'Borrar los scripts en Cloud Storage',
        gcs_parquet_delete_v2: 'Borrar los datos Parquet en Cloud Storage',
        approval_flow_cancel: 'Cancelar el flujo de aprobación',
        typesense_disable_category: 'Ocultar el atributo de Buscar atributos',
        pg_purge_children: 'Borrar las cargas registradas en INCA',
        attribute_group_delete: 'Borrar la categoría del catálogo'
      },
      preview_objects: '{n} objeto(s)',
      runs_count: '{n} ejecución(es)',
      tables_count: '{n} tabla(s)',
      versions_count: '{n} versión(es)',
      rows_period_hist: '{period} periodos · {hist} históricos'
    },
    load_months: {
      subtitle: 'Selecciona el mes y el año que quieres cargar sobre esta automatización ya creada.',
      background_hint: 'El proceso continuará en segundo plano. Puedes cerrar este diálogo y volver a consultarlo desde "Ver actividad".',
      periods_label: 'Periodos agregados',
      max_periods_hint: 'Hasta {max} periodos por solicitud.',
      too_many: 'Máximo 12 periodos permitidos.',
      summary_prefix: 'Cargarás',
      success_started: 'Carga iniciada para {count} periodo(s). Te avisaremos cuando termine.',
      badge_progress: 'Cargando {done}/{total}'
    },
    edit_script: {
      current_info: 'Automatización actual',
      use_case: 'Caso de uso',
      table_name: 'Nombre de tabla',
      current_version: 'Versión actual del script',
      current_filename: 'Nombre del archivo actual',
      new_script: 'Nuevo script SQL',
      parse_errors_title: 'Errores en el archivo SQL — corregir antes de continuar:',
      retrigger_info: 'Al guardar, se subirá una nueva versión y se re-ejecutará el pipeline para todos los periodos registrados (Lambda → Glue → callback → S3/GCS/BigQuery → Typesense).',
      warn_in_progress: 'La automatización está en ejecución. Editar ahora supersede la corrida en vuelo y dispara una nueva.',
      success: 'Script actualizado a v{version}; pipeline re-disparado.'
    }
  }
};
import utils from '../js/utils.js';
import roles from './configuration/roles';
/* import help_center from './configuration/help_center' */
import my_objects from './data_platform/my_objects';
import my_pendings from './data_platform/my_pendings';
import monitoring from './data_platform/monitoring';
import my_tasks from './data_platform/my_tasks';
import requests from './data_platform/requests';
import data_quality from './data_platform/data_quality';
import chatbots from './chatbots/chatbots';
import btns from './data_platform/btns';
import config_aud from './audience/config';
import use_metrics from './data_platform/metrics.js';
import campaign from './campaign/campaign';
import report_management from './data_platform/report_management.js';
import migrations from './data_platform/migrations.js';
words.roles = {};
utils.loadLanguage(words.roles, roles, 'es');
/* /words.help_center = {}
utils.loadLanguage(words.help_center2, help_center, 'es') */
words.my_objects = {};
utils.loadLanguage(words.my_objects, my_objects, 'es');
words.my_pendings = {};
utils.loadLanguage(words.my_pendings, my_pendings, 'es');
words.monitoring = {};
utils.loadLanguage(words.monitoring, monitoring, 'es');
words.my_tasks = {};
utils.loadLanguage(words.my_tasks, my_tasks, 'es');
words.requests = {};
utils.loadLanguage(words.requests, requests, 'es');
words.data_quality = {};
utils.loadLanguage(words.data_quality, data_quality, 'es');
words.chatbots = {};
utils.loadLanguage(words.chatbots, chatbots, 'es');
words.btns = {};
utils.loadLanguage(words.btns, btns, 'es');
words.aud = {
  config: {}
};
utils.loadLanguage(words.aud.config, config_aud, 'es');
words.use_metrics = {};
utils.loadLanguage(words.use_metrics, use_metrics, 'es');
words.performance_evaluation = {
  evaluation: 'Evaluación',
  des_evaluation: 'Completa tu evaluación de desempeño. Tus datos de identificación se envían de forma enmascarada al sistema de evaluación.',
  reload: 'Actualizar',
  not_configured: 'Evaluación no disponible',
  not_configured_detail: 'Aún no se ha configurado el sitio de evaluación de desempeño. Comunícate con el administrador de la plataforma.',
  token_error: 'No se pudo iniciar la evaluación',
  token_error_detail: 'No se pudo validar tu sesión con el sistema de evaluación. Intenta nuevamente en unos minutos.',
  debug_title: 'Datos enviados al iframe (solo local)'
};
words.campaign = {};
utils.loadLanguageRecursive(words.campaign, campaign, 'es');
words.report_management = {};
utils.loadLanguageRecursive(words.report_management, report_management, 'es');
words.migrations = {};
utils.loadLanguage(words.migrations, migrations, 'es');
export default words;